import $ from 'jquery'
import React from 'react'
import { getQueryDescription } from "./SearchLink";
import SearchLink from "./SearchLink";


function BriefStats({stats, numCitations}) {

    return (
        <div className={"brief-stats"}>
            <h4>Übersicht ({numCitations} {numCitations > 1 ? "Zitatanalysen" : "Zitatanalyse"})</h4>
            <div className={"list"}>
                {stats.map((stat, i) => (
                    <div key={i}>
                        <b>{stat.name} ({stat.items.length})</b>
                        <ul>
                            {stat.items.map((item, j) => (
                                <li key={j}>
                                    <SearchLink
                                        text={item}
                                        model={stat.model}
                                        field={stat.field}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default BriefStats


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/BriefStats.js